var __default__ = {root:'m_fea6bf1a',burger:'m_d4fb9cad'};
export default __default__;